import { useState } from "react";
import { Navigate, useParams, useLocation } from "react-router-dom";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useEffect } from "react";
import AthleteScore from "../athlete-scores/athlete-score";

export default function ProfileShared() {
  const auth = useAuthUser();
  const { profileId } = useParams();
  const location = useLocation();
  const [roleLocation, setRoleLocation] = useState(null);

  useEffect(() => {
    setRoleLocation(location.pathname.split("/")[1]);
  }, [location.pathname]);

  const profileBaseRole =
    auth?.user?.role === "highschool" ? "highschool-coach" : auth?.user?.role;

  if (auth && roleLocation !== profileBaseRole) {
    return <Navigate to={`/${profileBaseRole}/athlete-profile/${profileId}`} />;
  }

  return (
    <AthleteScore
      userId={profileId}
      showOffers={true}
      showTrackittScore={true}
      showPositionScore={true}
      searchEvent={false}
      showProfile={true}
      showRank={true}
      showLikes={true}
      sharedProfile={true}
    />
  );
}
